<template>
  <router-view></router-view>
</template>

<script></script>

<style>
@media print {

  .v-app-bar,
  .v-navigation-drawer,
  .v-footer {
    display: none !important;
  }

  /* Reset v-main padding */
  .v-main {
    padding-top: 0 !important;
    padding-left: 0 !important;
  }

  /* Optional: if your main content wrapper has margins */
  .v-main__wrap {
    margin: 0 !important;
  }
}
</style>
